import {
  ReleaseNote,
  ReleaseNotesResponse,
  UnreadReleaseNotesResponse,
} from '../types';
import { RELEASE_NOTE_POPUP_DISMISSED_KEY } from '../utils/storageKeys';
import { getHeaders, tosApi } from './tosApi';

export { RELEASE_NOTE_POPUP_DISMISSED_KEY };

export const releaseNotesApi = tosApi.injectEndpoints({
  endpoints: (build) => ({
    getLatestReleaseNote: build.query<ReleaseNote | null, void>({
      query: () => ({
        url: 'core/release-notes/latest',
        method: 'GET',
        headers: getHeaders,
        responseHandler: async (response) =>
          response.status === 204 ? null : response.json(),
      }),
      providesTags: ['ReleaseNote'],
    }),
    getReleaseNotes: build.query<ReleaseNotesResponse, number>({
      query: (page) => ({
        url: `core/release-notes?page=${page}`,
        method: 'GET',
        headers: getHeaders,
      }),
      providesTags: ['ReleaseNote'],
    }),
    getUnreadReleaseNotes: build.query<UnreadReleaseNotesResponse, void>({
      query: () => ({
        url: 'core/release-notes/unread',
        method: 'GET',
        headers: getHeaders,
      }),
      providesTags: ['ReleaseNote'],
    }),
    markReleaseNoteRead: build.mutation<void, number>({
      query: (id) => ({
        url: `core/release-notes/${id}/mark-read`,
        method: 'POST',
        headers: getHeaders,
      }),
      invalidatesTags: ['ReleaseNote'],
    }),
    markAllReleaseNotesRead: build.mutation<void, void>({
      query: () => ({
        url: 'core/release-notes/mark-all-read',
        method: 'POST',
        headers: getHeaders,
      }),
      invalidatesTags: ['ReleaseNote'],
    }),
    getPendingPopup: build.query<ReleaseNote | null, void>({
      query: () => ({
        url: 'core/release-notes/popup-pending',
        method: 'GET',
        headers: getHeaders,
        responseHandler: async (response) =>
          response.status === 204 ? null : response.json(),
      }),
      providesTags: ['ReleaseNote'],
    }),
    markPopupShown: build.mutation<void, number>({
      query: (id) => ({
        url: `core/release-notes/${id}/popup-shown`,
        method: 'POST',
        headers: getHeaders,
      }),
      invalidatesTags: ['ReleaseNote'],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetLatestReleaseNoteQuery,
  useLazyGetReleaseNotesQuery,
  useGetUnreadReleaseNotesQuery,
  useMarkReleaseNoteReadMutation,
  useMarkAllReleaseNotesReadMutation,
  useGetPendingPopupQuery,
  useMarkPopupShownMutation,
} = releaseNotesApi;
